module.exports = __webpack_public_path__ + "static/media/mockupui_800px.046e2d97.png";